import React from 'react';
import { Link } from 'react-router-dom';
const OurCourses = () => {
  const programs = [
    {
      id: 'foundation',
      title: 'Foundation Programmes',
      description: 'Build a strong academic foundation with our comprehensive foundation programs designed to prepare you for undergraduate studies.',
      duration: '1 Year',
      level: 'Pre-University',
      link: '/academics/foundation'
    },
    {
      id: 'business',
      title: 'Business & Management',
      description: 'Develop essential business skills and knowledge to excel in the dynamic world of commerce and management.',
      duration: '3-4 Years',
      level: 'Undergraduate',
      link: '/academics/business-management'
    },
    {
      id: 'computing',
      title: 'Computing & IT',
      description: 'Grow your technical expertise in computer science, software development, and information technology.',
      duration: '3-4 Years',
      level: 'Undergraduate',
      link: '/academics/computing-it'
    },
    {
      id: 'law',
      title: 'Faculty of Law',
      description: 'Pursue a career in law with our comprehensive legal education programs.',
      duration: '4-5 Years',
      level: 'Undergraduate',
      link: '/academics/law'
    },
    {
      id: 'healthcare',
      title: 'Health & Social Care',
      description: 'Prepare for a rewarding career in healthcare and social services with our specialized programs.',
      duration: '3-4 Years',
      level: 'Undergraduate',
      link: '/academics/health-social-care'
    },
    {
      id: 'tourism',
      title: 'Tourism & Hospitality',
      description: 'Develop skills for the global tourism and hospitality industry with our hands-on programs.',
      duration: '3-4 Years',
      level: 'Undergraduate',
      link: '/academics/tourism-hospitality'
    },
    {
      id: 'short-courses',
      title: 'Short Courses',
      description: 'Enhance your skills with our flexible short-term certification programs.',
      duration: '3-6 Months',
      level: 'Certificate',
      link: '/academics/short-courses'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-blue-900 py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Our Academic Programs</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Discover a wide range of undergraduate, graduate, and professional programs designed to help you achieve your academic and career goals.
          </p>
        </div>
      </div>

      {/* Programs Grid */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {programs.map((program) => (
            <div key={program.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
              <div className="p-6">
                <h2 className="text-xl font-bold text-gray-800 mb-3">{program.title}</h2>
                <p className="text-gray-600 mb-4">{program.description}</p>
                <div className="flex justify-between text-sm text-gray-500 mb-4">
                  <span>Duration: {program.duration}</span>
                  <span>Level: {program.level}</span>
                </div>
                <Link
                  to={program.link}
                  className="inline-block bg-blue-900 text-white px-6 py-2 rounded-md hover:bg-blue-800 transition-colors"
                >
                  Learn More
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-blue-50 py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Need Help Choosing a Program?</h2>
          <p className="text-gray-600 max-w-2xl mx-auto mb-8">
            Our academic advisors are here to help you find the perfect program that matches your interests and career goals.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/contact"
              className="bg-blue-900 text-white px-8 py-3 rounded-md font-medium hover:bg-blue-800 transition-colors"
            >
              Contact an Advisor
            </Link>
            <Link
              to="/admissions/apply-now"
              className="border-2 border-blue-900 text-blue-900 px-8 py-3 rounded-md font-medium hover:bg-blue-50 transition-colors"
            >
              Apply Now
            </Link>
          </div>
        </div>
      </div>

      
    </div>
  );
};

export default OurCourses;
